import { render, staticRenderFns } from "./settingDialog.vue?vue&type=template&id=345529dc"
import script from "./settingDialog.vue?vue&type=script&lang=js"
export * from "./settingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports